import axios from "axios";

export const descargarDocumento = async (ubicacion) => {
  try {
    const response = await axios.get(
      `https://suadesarrollo.azurewebsites.net/api/AzureStorage/Descargar?ubicacion=${encodeURIComponent(
        ubicacion
      )}`,
      {
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
      }
    );

    const url = response?.data?.url;

    if (!url) {
      console.error("No se encontró la URL del documento");
      return;
    }

    // 🔥 Forma segura (evita bloqueo de popup)
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.rel = "noopener noreferrer";

    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error("Error al descargar documento:", error);
  }
};
